import { useSelector } from "react-redux";
import { RootState } from "toolkit/store";

const useToast = () => {
  const { showToast, message, type } = useSelector((state: RootState) => state.toast);
  return [showToast, message, type];
};

export default useToast;
